import React, { useEffect, useState } from "react";
import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import axiosClient from "../api/axiosClient";
import { useAppToast } from "../components/brand/useAppToast";

export default function SellingSettingsPanel({ propertyId = null }) {
  const [information, setInformation] = useState("");
  const [packFee, setPackFee] = useState("0.00");
  const [usesGlobalDefault, setUsesGlobalDefault] = useState(false);
  const { showToast, toastNode } = useAppToast();

  useEffect(() => {
    const params = propertyId ? { params: { property_id: propertyId } } : undefined;
    axiosClient.get("/settings/selling/", params).then((response) => {
      setInformation(response.data.information || "");
      setPackFee(response.data.pack_fee || "0.00");
      setUsesGlobalDefault(Boolean(response.data.uses_global_default));
    });
  }, [propertyId]);

  const save = async () => {
    const body = { information, pack_fee: packFee };
    if (propertyId) body.property_id = propertyId;
    await axiosClient.put("/settings/selling/", body);
    setUsesGlobalDefault(false);
    showToast(propertyId ? "Property selling information saved." : "Selling information saved.");
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Selling my home</Typography>
      {propertyId && usesGlobalDefault && (
        <Alert severity="info">
          Showing the global default. Save to create a copy for this property.
        </Alert>
      )}
      {!propertyId && (
        <Typography variant="body2" color="text.secondary">
          Global default used when a property has no override.
        </Typography>
      )}
      <TextField
        label="Information about selling"
        multiline
        minRows={6}
        value={information}
        onChange={(event) => setInformation(event.target.value)}
      />
      <TextField
        label="Management pack fee"
        value={packFee}
        onChange={(event) => setPackFee(event.target.value)}
      />
      <Button variant="contained" onClick={save} startIcon={<SaveIcon />}>
        + Save selling information
      </Button>
      {toastNode}
    </Stack>
  );
}
